var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* globals AFRAME */
import spirit_component from "../../gui/components/ghost";
import { AFRAME } from "../root";
import { raiseCustomEvent } from "../util";
var THREE = window.THREE;
export var GrabAndDropEvents = {
    GRAB_START: "grab-start",
    GRABBING_START: 'grabbing-starting',
    GRAB_RELEASE: 'grab-release',
    GRABBING_ENDED: 'grabbing-ended',
    DROPPED_GRABBED_DATA: 'drop-grabbed-data',
    GRAB_OVER: 'grab-over',
    GRAB_OUT: 'grab-out',
    GRAB_TARGET_CHANGE: 'grab-target-change'
};
export default function () {
    spirit_component();
    AFRAME.registerSystem('grabanddropsystem', {
        init: function () {
            this.spiritReferences = {};
            this.inputDeviceState = {};
            this.inputDevices = {};
            this.spiritTargets = {};
            this.closetsTargets = {};
            this.scene = this.sceneEl;
            customEventListener(GrabAndDropEvents.GRAB_START, this.onGrabStart.bind(this));
            customEventListener(GrabAndDropEvents.GRAB_RELEASE, this.onGrabRelease.bind(this));
            customEventListener(GrabAndDropEvents.GRAB_OVER, this.onGrabOver.bind(this));
            customEventListener(GrabAndDropEvents.GRAB_OUT, this.onGrabOut.bind(this));
            this.scene.addEventListener('mouseup', function (event) {
                var inputDevice = setInputDevice(event);
                if (inputDevice) {
                    var details = {
                        inputDeviceId: inputDevice.id
                    };
                    raiseCustomEvent(GrabAndDropEvents.GRAB_RELEASE, details);
                }
            });
        },
        onGrabOut: function (evt) {
            var deviceId = evt.deviceId, component = evt.component;
            var spiritTargets = this.spiritTargets;
            var spiritReferences = this.spiritReferences;
            if (spiritReferences[deviceId]) {
                var spiritReference = spiritReferences[deviceId];
                if (spiritTargets[deviceId] && spiritTargets[deviceId].includes(component)) {
                    spiritTargets[deviceId] = spiritTargets[deviceId].filter(function (x) { return x !== component; });
                    var closest = this.getClosest(deviceId);
                    if (component !== closest) {
                        spiritReference.emit(GrabAndDropEvents.GRAB_TARGET_CHANGE, {
                            component: closest,
                            deviceId: deviceId
                        });
                    }
                }
            }
        },
        onGrabOver: function (evt) {
            var deviceId = evt.deviceId, component = evt.component;
            var spiritTargets = this.spiritTargets;
            var spiritReferences = this.spiritReferences;
            if (spiritReferences[deviceId]) {
                var spiritReference = spiritReferences[deviceId];
                spiritTargets[deviceId] = spiritTargets[deviceId] || [];
                if (spiritTargets[deviceId] && !spiritTargets[deviceId].includes(component)) {
                    spiritTargets[deviceId].push(component);
                    var closest = this.getClosest(deviceId);
                    if (component === closest) {
                        spiritReference.emit(GrabAndDropEvents.GRAB_TARGET_CHANGE, { component: component, deviceId: deviceId });
                    }
                }
            }
        },
        onGrabRelease: function (evt) {
            var inputDeviceId = evt.inputDeviceId;
            var closestItem = this.getClosest(inputDeviceId);
            if (closestItem === null || closestItem === void 0 ? void 0 : closestItem.el) {
                var details = this.inputDeviceState[inputDeviceId];
                var inputDevice = details.inputDevice, data = details.data, category = details.category;
                closestItem.el.emit(GrabAndDropEvents.DROPPED_GRABBED_DATA, { inputDevice: inputDevice, data: data, category: category });
            }
            this.clearInputDeviceData(inputDeviceId);
            this.killGhost(inputDeviceId);
            raiseCustomEvent(GrabAndDropEvents.GRABBING_ENDED, { deviceId: inputDeviceId });
        },
        clearInputDeviceData: function (inputDeviceId) {
            var inputDevices = this.inputDeviceState;
            var spiritTargets = this.spiritTargets;
            if (inputDevices[inputDeviceId]) {
                delete inputDevices[inputDeviceId];
                spiritTargets[inputDeviceId] = [];
            }
        },
        getClosest: function (inputDeviceId) {
            var _a, _b;
            var spiritTargets = this.spiritTargets;
            var inputDevices = this.inputDeviceState;
            if ((_a = inputDevices[inputDeviceId]) === null || _a === void 0 ? void 0 : _a.inputDevice) {
                if ((_b = spiritTargets[inputDeviceId]) === null || _b === void 0 ? void 0 : _b.length) {
                    var ray = inputDevices[inputDeviceId].inputDevice.getRay();
                    var position_1 = getRayposition(ray);
                    var sorted = spiritTargets[inputDeviceId].sort(function (a, b) {
                        return distanceBetweenPointsFast(position_1, a.position) - distanceBetweenPointsFast(position_1, b.position);
                    });
                    return sorted[0];
                }
            }
            return null;
        },
        killGhost: function (inputDeviceId) {
            var spiritReferences = this.spiritReferences;
            if (spiritReferences[inputDeviceId]) {
                spiritReferences[inputDeviceId].setAttribute(GhostAttributes.Die, true);
                delete spiritReferences[inputDeviceId];
            }
        },
        createGhost: function (spiritContent) {
            if (!spiritContent) {
                throw 'no spirit';
            }
            ;
            var spirit = document.createElement('a-spirit');
            spirit.appendChild(spiritContent);
            return spirit;
        },
        onGrabStart: function (evt) {
            this.setInputDeviceState(evt);
            var component = evt.component, inputDevice = evt.inputDevice, spirit = evt.spirit, category = evt.category;
            if (inputDevice === null || inputDevice === void 0 ? void 0 : inputDevice.id) {
                console.log("grab start ".concat(inputDevice.id));
                var spiritReferences = this.spiritReferences;
                this.killGhost(inputDevice.id);
                var worldPosition = new THREE.Vector3();
                component.el.object3D.getWorldPosition(worldPosition);
                var newGhost = this.createGhost(spirit);
                spiritReferences[inputDevice.id] = newGhost;
                newGhost.setAttribute(GhostAttributes.Device, inputDevice.id);
                newGhost.setAttribute(GhostAttributes.Position, toPosition(worldPosition));
                newGhost.setAttribute(GhostAttributes.Alive, true);
                this.scene.appendChild(newGhost);
                raiseCustomEvent(GrabAndDropEvents.GRABBING_START, { category: category, deviceId: inputDevice.id });
            }
        },
        setInputDeviceState: function (evt) {
            var _a;
            var inputDevice = evt.inputDevice, data = evt.data, category = evt.category, spirit = evt.spirit, cursorEl = evt.cursorEl;
            this.inputDeviceState = __assign(__assign({}, this.inputDeviceState), (_a = {}, _a[inputDevice.id] = {
                inputDevice: inputDevice,
                data: data,
                spirit: spirit,
                cursorEl: cursorEl,
                category: category
            }, _a));
        }
    });
}
function distanceBetweenPointsFast(pointA, pointB) {
    if (!pointB || !pointA) {
        return 100000000;
    }
    var dx = pointA.x - pointB.x;
    var dy = pointA.y - pointB.y;
    var dz = pointA.z - pointB.z;
    return (dx * dx + dy * dy + dz * dz);
}
export function lerp3(v1, v2, t) {
    return {
        x: v1.x + (v2.x - v1.x) * t,
        y: v1.y + (v2.y - v1.y) * t,
        z: v1.z + (v2.z - v1.z) * t
    };
}
export function lerp(x1, x2, t) {
    return x1 + (x2 - x1) * t;
}
export function calculateEndPoint(origin, direction, distance) {
    // Scale the direction vector by the distance
    var scaledDirection = {
        x: direction.x * distance,
        y: direction.y * distance,
        z: direction.z * distance
    };
    // Add the scaled direction to the origin to get the end point
    return {
        x: origin.x + scaledDirection.x,
        y: origin.y + scaledDirection.y,
        z: origin.z + scaledDirection.z
    };
}
export var GhostAttributes;
(function (GhostAttributes) {
    GhostAttributes["Die"] = "die";
    GhostAttributes["Device"] = "device";
    GhostAttributes["Alive"] = "alive";
    GhostAttributes["Position"] = "position";
})(GhostAttributes || (GhostAttributes = {}));
;
;
// The hook can optionally accept a callback to be executed when the event is triggered
export var customEventListener = function (eventName, callback) {
    // Event handler to call the provided callback
    var handler = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, callback(event.detail, event)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // Add event listener
    window.addEventListener(eventName, handler);
    // Clean up
    return function () {
        window.removeEventListener(eventName, handler);
    };
};
var inputDeviceContext = {};
export function setInputDevice(evnt) {
    var _a, _b;
    var cursor = (((_a = evnt === null || evnt === void 0 ? void 0 : evnt.detail) === null || _a === void 0 ? void 0 : _a.cursorEl) || ((_b = evnt === null || evnt === void 0 ? void 0 : evnt.detail) === null || _b === void 0 ? void 0 : _b.el));
    if (cursor === null || cursor === void 0 ? void 0 : cursor.$id) {
        if (!inputDeviceContext[cursor === null || cursor === void 0 ? void 0 : cursor.$id]) {
            var device = {
                id: cursor === null || cursor === void 0 ? void 0 : cursor.$id,
                emit: function (evtName, details) {
                    raiseCustomEvent(evtName, details);
                },
                getPosition: function () {
                    return evnt.detail.cursorEl.object3D.position;
                },
                getRay: function () {
                    return cursor === null || cursor === void 0 ? void 0 : cursor.components.raycaster.raycaster;
                }
            };
            inputDeviceContext[cursor === null || cursor === void 0 ? void 0 : cursor.$id] = device;
        }
        return inputDeviceContext[cursor === null || cursor === void 0 ? void 0 : cursor.$id];
    }
    return null;
}
export function getRayposition(ray) {
    if (ray === null || ray === void 0 ? void 0 : ray.ray) {
        var _a = ray.ray, origin_1 = _a.origin, direction = _a.direction;
        return origin_1;
    }
    return null;
}
export function getInputDevice(id) {
    if (id) {
        return inputDeviceContext[id];
    }
}
function toPosition(worldPosition) {
    return "".concat(worldPosition.x, " ").concat(worldPosition.y, " ").concat(worldPosition.z);
}
